module.exports = __webpack_public_path__ + "img/vegetable-burdock-190x100.6c9a1ad3.jpg";